import '@/metrics';
import '@/components/button';
import '@/components/form_handler';
import '@/components/horizontal_scroller';
import '@/components/report_modal';
import '@/components/searchbox';
import '@/components/video_item';
import '@/components/video_list';
import '@/components/video_info';
import '@/components/image_list';
import '@/components/social_login';
import '@/components/select';
import '@/components/video_download';
import '@/components/video_favorite';
import '@/components/video_channel_toolbar';
import '@/stores/app';
import '@/stores/layout_switcher';
import '@/stores/entry_flow';

import { getNotificationStore } from '@/stores/notification';
import { getDeviceStore } from '@/stores/device';
import { getModalHandlerStore } from '@/stores/modal_handler';
import { getScrollLockStore } from '@/stores/scroll_lock';
import { getModalStore } from '@/stores/modal';
import { getRecommendationStore } from '@/stores/recommendation';

getNotificationStore();
getDeviceStore();
const scrollLockStore = getScrollLockStore();
getModalHandlerStore(scrollLockStore);
getModalStore(scrollLockStore);
getRecommendationStore();
